// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.5859 21L21.1925 22.6067L22.6068 21.1925L2.80777 1.39349L1.39355 2.8077L2.11974 3.53388C2.04627 3.67307 2.00468 3.83168 2.00468 4.00001V20C2.00468 20.5523 2.4524 21 3.00468 21H19.5859ZM17.5859 19H4.00468V5.41883L10.5859 12L17.5859 19ZM22.0047 4.00001V17.7622L20.0047 15.7622V12V8.00001V5.00001H9.24251L7.24251 3.00001H21.0047C21.557 3.00001 22.0047 3.44772 22.0047 4.00001Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
